import { get, post, put, patch } from "../libs/https";
const publicPath = process.env.BASE_URL;

export const login = async (email, password) => {
  /* eslint-disable */
  return new Promise(async (resolve) => {
    if (!email || !password) {
      return resolve(false);
    }

    let result = await post(`${publicPath}api/auth`, { email, password });
    if (result.error || !result.trusted) {
      resolve(result);
      window.sessionStorage.clear();
      return;
    }

    window.sessionStorage.setItem(
      "access_token",
      "Bearer " + result.accessToken
    );
    window.sessionStorage.setItem("puid", result.puid);
    window.sessionStorage.setItem('name', result.user.name);
    resolve(result);
  });
};

export const renew = async () => {
  /* eslint-disable */
  return new Promise(async (resolve) => {

    let result = await patch(`${publicPath}api/auth`, {});
    if (result.error || !result.trusted) {
      resolve(result);
      window.sessionStorage.clear();
      return;
    }

    window.sessionStorage.setItem(
      "access_token",
      "Bearer " + result.accessToken
    );
    resolve(result);
  });
};

/**
 * Checks that the password meets our password requirements of -
 * Must be at least 8 characters, 1 number, 1 capital letter, and 1 non alpha numerical character.
 * @param password: string
 * @returns boolean
 */
export const validatePassword = (password) => {
  const pass = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,}$/;
  return pass.test(password);
};

export const checkEmail = async (email) => {
  let res = await post(`${publicPath}api/register/check/email`, { email });
  return res.found;
};

export const checkPhone = async (phone) => {
  let res = await post(`${publicPath}api/register/check/phone`, { phone });
  return res.found;
};

export const validEmailAddress = (email) => {
  const emailTest = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailTest.test(email);
};

export const getDefaultQuestions = async () => {
  return await get(`${publicPath}api/auth/questions`);
};

export const checkPhoneCode = async (phone, code) => {
  let res = await post(`${publicPath}api/register/verify/phone`, {
    phone,
    code,
  });
  return res.status === 200 ? true : false;
};

export const sendPhoneCode = async (phone) => {
  return await get(`${publicPath}api/register/verify/phone?phone=${phone}`);
};

export const sendPassResetCode = async (email) => {
  return await put(`${publicPath}api/auth`, { email });
};

export const newLoanAppUser = async (user) => {
  return await post(`${publicPath}api/register/user`, user);
};

export const verifyTrustedDevice = async (params) => {
  return await post(`${publicPath}api/auth/questions`, params);
};

export const resetUsersPassword = async (params) => {
  return await post(`${publicPath}api/auth/reset`, params);
};

export const getInvitation = async (guid) => {
  return await get(`${publicPath}api/register/invited/guid/${guid}`);
};

export const getUserInfo = async () => {
  return await get(`${publicPath}api/user`);
};

export const getDomainInfo = async () => {
  return await post(`${publicPath}api/ssl`);
};